module.exports = __webpack_public_path__ + "static/media/back_gray.799943f0.svg";